function announcementBar() {
	// Configuration
  let lastScrollTop = 0;
  let isScrollingDown = false;
  const scrollThreshold = 5; // Seuil pour éviter les micro-mouvements
	const announcementBar = document.querySelector('.shopify-section--announcement-bar');
  
  // Fonction throttle optimisée avec requestAnimationFrame
  function throttle(callback) {
    let requestId = null;
    return function(...args) {
      if (requestId === null) {
        requestId = requestAnimationFrame(() => {
          requestId = null;
          callback.apply(this, args);
        });
      }
    };
  }
  
  // Méthode appelée quand on scroll vers le haut
  function up() {
    announcementBar.style.transition = 'transform 0.3s ease-out';
    announcementBar.style.position = 'sticky';
    announcementBar.style.top = '0';
    announcementBar.style.zIndex = '20';
    announcementBar.style.transform = 'translateY(0)';
    document.documentElement.style.setProperty('--sticky-announcement-bar-enabled', 1);
  }
  
  // Méthode appelée quand on scroll vers le bas
  function down() {
    announcementBar.style.transition = 'transform 0.3s ease-out';
    announcementBar.style.transform = 'translateY(-100%)';
    
    // Après l'animation, remet en position relative
    setTimeout(() => {
      announcementBar.style.position = 'relative';
      announcementBar.style.top = 'auto';
      announcementBar.style.zIndex = 'auto';
      announcementBar.style.transform = '';
      announcementBar.style.transition = '';
    }, 300);
    
    document.documentElement.style.setProperty('--sticky-announcement-bar-enabled', 0);
  }
  
  // Détection optimisée de la direction du scroll
  function onScroll() {
    if (window.scrollY < 0) return;
    
    const currentScrollTop = window.scrollY;
    const scrollDifference = currentScrollTop - lastScrollTop;
    
    // Détermine la direction du scroll avec un seuil
    if (Math.abs(scrollDifference) > scrollThreshold) {
      const wasScrollingDown = isScrollingDown;
      isScrollingDown = scrollDifference > 0;
      
      // Si la direction change, appelle la méthode correspondante
      if (wasScrollingDown !== isScrollingDown) {
        if (isScrollingDown) {
          down();
        } else {
          up();
        }
      }
    }
    
    lastScrollTop = currentScrollTop;
  }
  
  // Active la détection seulement si les animations sont activées
  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    const onScrollThrottled = throttle(onScroll);
    window.addEventListener("scroll", onScrollThrottled);
  }
}

function logoScaling() {
  const header = document.querySelector('.header');
  if (!header) return;
  
  // Fonction throttle optimisée avec requestAnimationFrame
  function throttle(callback) {
    let requestId = null;
    return function(...args) {
      if (requestId === null) {
        requestId = requestAnimationFrame(() => {
          requestId = null;
          callback.apply(this, args);
        });
      }
    };
  }
  
  function onScroll() {
    if (window.scrollY > 10) {
      // Dès qu'on scroll de plus de 10px, on réduit le logo
      header.classList.add('is-scrolled');
    } else {
      // En haut de page, le logo reste agrandi
      header.classList.remove('is-scrolled');
    }
  }
  
  // Vérifie l'état initial
  onScroll();
  
  // Active la détection du scroll
  const onScrollThrottled = throttle(onScroll);
  window.addEventListener("scroll", onScrollThrottled);
}

// Gestionnaire échantillons: ajout/suppression + état localStorage + refresh
(function() {
  const STORAGE_KEY = 'cart_samples_accepted';

  async function getCart() {
    try {
      const res = await fetch(`${Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
      return await res.json();
    } catch (e) { return null; }
  }

  async function dispatchRefresh() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}
  }

  async function addSample(variantId) {
    const loader = document.querySelector('.samples-loader');
    if (loader) {
      loader.setAttribute('aria-busy', 'true');
      loader.style.visibility = 'visible';
      loader.style.opacity = '1';
    }
    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('properties[_samples]', 'true');
    const res = await fetch(`${Shopify.routes.root}cart/add.js`, { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
    if (!res.ok) {
      if (loader) {
        loader.setAttribute('aria-busy', 'false');
        loader.style.visibility = 'hidden';
        loader.style.opacity = '0';
      }
      return false;
    }
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
    await dispatchRefresh();
    if (loader) {
      loader.setAttribute('aria-busy', 'false');
      loader.style.visibility = 'hidden';
      loader.style.opacity = '0';
    }
    return true;
  }

  async function removeSample(lineKeyOrVariantId, isLineKey = true) {
    const loader = document.querySelector('.samples-loader');
    if (loader) {
      loader.setAttribute('aria-busy', 'true');
      loader.style.visibility = 'visible';
      loader.style.opacity = '1';
    }
    if (isLineKey) {
      const res = await fetch(`${Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lineKeyOrVariantId, quantity: 0 }) });
      if (!res.ok) return false;
      const cartContent = await res.json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cartContent } }));
      await dispatchRefresh();
      if (loader) {
        loader.setAttribute('aria-busy', 'false');
        loader.style.visibility = 'hidden';
        loader.style.opacity = '0';
      }
      return true;
    } else {
      await fetch(`${Shopify.routes.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [lineKeyOrVariantId]: 0 } }) });
      await dispatchRefresh();
      if (loader) {
        loader.setAttribute('aria-busy', 'false');
        loader.style.visibility = 'hidden';
        loader.style.opacity = '0';
      }
      return true;
    }
  }

  function hasSampleLine(cart, variantId) {
    return cart?.items?.some((item) => item.id === variantId && item.properties && (item.properties._sample === 'true' || item.properties._samples === 'true'));
  }
  function getSampleLineKey(cart, variantId) {
    const line = cart?.items?.find((item) => item.id === variantId && item.properties && (item.properties._sample === 'true' || item.properties._samples === 'true'));
    return line?.key || null;
  }

  async function syncCheckbox(checkbox) {
    const variantId = parseInt(checkbox.getAttribute('data-variant-id'));
    if (!variantId) return;
    const saved = localStorage.getItem(STORAGE_KEY);
    const cart = await getCart();
    const totalPrice = cart?.total_price || 0;
    const alreadyInCart = hasSampleLine(cart, variantId);

    if (saved === '1') {
      checkbox.checked = true;
      if (totalPrice > 0 && !alreadyInCart) {
        await addSample(variantId);
      } else if (alreadyInCart) {
        const lineKey = getSampleLineKey(cart, variantId);
        if (lineKey && cart.items.find(i => i.key === lineKey)?.quantity > 1) {
          await fetch(`${Shopify.routes.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: 1 }) });
          await dispatchRefresh();
        }
      }
    } else if (saved === '0') {
      checkbox.checked = false;
      if (alreadyInCart) {
        const lineKey = getSampleLineKey(cart, variantId);
        if (lineKey) {
          await removeSample(lineKey, true);
        } else {
          await removeSample(variantId, false);
        }
      }
    } else {
      checkbox.checked = alreadyInCart;
    }
  }

  async function onCheckboxChange(event) {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement) || !checkbox.classList.contains('js-samples-checkbox')) return;
    const variantId = parseInt(checkbox.getAttribute('data-variant-id'));
    if (!variantId) return;
    const cart = await getCart();
    const totalPrice = cart?.total_price || 0;
    const alreadyInCart = hasSampleLine(cart, variantId);

    if (checkbox.checked) {
      localStorage.setItem(STORAGE_KEY, '1');
      if (totalPrice === 0 || alreadyInCart) {
        checkbox.checked = alreadyInCart;
        return;
      }
      await addSample(variantId);
    } else {
      localStorage.setItem(STORAGE_KEY, '0');
      if (alreadyInCart) {
        const lineKey = getSampleLineKey(cart, variantId);
        if (lineKey) {
          await removeSample(lineKey, true);
        } else {
          await removeSample(variantId, false);
        }
      }
    }
  }

  function bindSamplesHandlers(root = document) {
    root.addEventListener('change', onCheckboxChange);
    Array.from(root.querySelectorAll('.js-samples-checkbox')).forEach((cb) => { syncCheckbox(cb); });
  }

  document.addEventListener('DOMContentLoaded', function() {
    bindSamplesHandlers(document);
    document.addEventListener('cart:refresh', () => Array.from(document.querySelectorAll('.js-samples-checkbox')).forEach(syncCheckbox));
    document.addEventListener('cart:change', () => Array.from(document.querySelectorAll('.js-samples-checkbox')).forEach(syncCheckbox));
  });
})();


document.addEventListener('DOMContentLoaded', function() {
  announcementBar();
  logoScaling();
});

// Ouvrir le cart drawer automatiquement sur la home si ?cart=true
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (window.themeVariables?.settings?.pageType !== 'index') return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('cart') === 'true') {
      const drawer = document.getElementById('cart-drawer');
      if (drawer) {
        // Utilise l'API du composant (CartDrawer) si disponible
        const openDrawer = () => {
          if (typeof drawer.show === 'function') {
            drawer.show();
          } else {
            drawer.setAttribute('open', '');
          }
        };
        if (window.customElements && typeof window.customElements.whenDefined === 'function' && !window.customElements.get('cart-drawer')) {
          window.customElements.whenDefined('cart-drawer').then(() => {
            const el = document.getElementById('cart-drawer');
            if (el && typeof el.show === 'function') {
              el.show();
            } else {
              el?.setAttribute('open', '');
            }
          });
        } else {
          openDrawer();
        }
      }
    }
  } catch (e) {}
});

window.addEventListener('product:rerender', function() {
  console.log('product:rerender');
});

// Réinitialiser les avis Skeepers après pagination/filtrage des collections et recherche
document.addEventListener('facet:update', function() {
  // Attendre que le DOM soit complètement mis à jour et que les images soient chargées
  setTimeout(function() {
    if (typeof SkeepersProductWidget !== 'undefined' && typeof SkeepersProductWidget.generate === 'function') {
      SkeepersProductWidget.generate();
      console.log('Skeepers réinitialisé après facet:update');
    }
  }, 300);
});

// Observer les changements dans les product-list pour détecter l'ajout de nouveaux produits
const productListObserver = new MutationObserver(function(mutations) {
  let shouldReinit = false;

  for (const mutation of mutations) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Vérifier si des product-card ont été ajoutées
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.tagName === 'PRODUCT-CARD' || node.querySelector('product-card'))) {
          shouldReinit = true;
          break;
        }
      }
    }
    if (shouldReinit) break;
  }

  if (shouldReinit) {
    setTimeout(function() {
      if (typeof SkeepersProductWidget !== 'undefined' && typeof SkeepersProductWidget.generate === 'function') {
        SkeepersProductWidget.generate();
        console.log('Skeepers réinitialisé après ajout de produits');
      }
    }, 200);
  }
});

// Observer tous les product-list dans la page
document.addEventListener('DOMContentLoaded', function() {
  const productLists = document.querySelectorAll('product-list');
  productLists.forEach(function(element) {
    productListObserver.observe(element, {
      childList: true,
      subtree: false
    });
  });

  // Réobserver après chaque changement de page (au cas où de nouveaux product-list sont créés)
  document.addEventListener('facet:update', function() {
    setTimeout(function() {
      const newProductLists = document.querySelectorAll('product-list');
      newProductLists.forEach(function(element) {
        productListObserver.observe(element, {
          childList: true,
          subtree: false
        });
      });
    }, 100);
  });
});